import React from 'react';
import { 
  Building2, 
  Calendar, 
  // FileText, 
  ExternalLink, 
  // Shield, 
  Phone,
  Users,
  Globe,
  Award,
  History,
  MapPin,
  Settings,
  // CreditCard,
  // HelpCircle,
  // Mail,
  Database,
  // Zap,
  // UserCheck,
  Star,
  PlayCircle,
  GraduationCap,
  Cpu,
} from 'lucide-react';

// Icon mapping for different items
export const getIcon = (itemId: string, label: string): React.ReactNode => {
  const iconMap: { [key: string]: React.ReactNode } = {
    // About Us icons
    'values': <Award className="w-4 h-4" />,
    'guiding-principles': <Settings className="w-4 h-4" />,
    'smith-way': <Star className="w-4 h-4" />,
    // 'AO Smith India Journey': <History className="w-4 h-4" />,
    // 'leadership': <Users className="w-4 h-4" />,
    'brands': <Building2 className="w-4 h-4" />,
    'products': <Database className="w-4 h-4" />,
    'ao-smith-global': <Globe className="w-4 h-4" />,
    'bangladesh': <MapPin className="w-4 h-4" />,
    'india': <MapPin className="w-4 h-4" />,
    'srilanka': <MapPin className="w-4 h-4" />,
    
    // Events icons
    'news': <Calendar className="w-4 h-4" />,
    'birthdays': <Calendar className="w-4 h-4" />,
    'work-anniversaries': <Calendar className="w-4 h-4" />,
    'engagement': <Calendar className="w-4 h-4" />,
    
    // Quick Links icons
    // 'advance-tool': <Settings className="w-4 h-4" />,
    // 'ar-tool': <Settings className="w-4 h-4" />,
    // 'alternative-part-code': <Database className="w-4 h-4" />,
    // 'dashboard': <Database className="w-4 h-4" />,
    // 'employee-expense-bgd': <CreditCard className="w-4 h-4" />,
    // 'employee-expense-ind': <CreditCard className="w-4 h-4" />,
    // 'employee-expense-lka': <CreditCard className="w-4 h-4" />,
    // 'employee-discounts': <CreditCard className="w-4 h-4" />,
    // 'hrms': <UserCheck className="w-4 h-4" />,
    // 'it-helpdesk': <HelpCircle className="w-4 h-4" />,
    // 'invoice-cancellation': <FileText className="w-4 h-4" />,
    // 'jv-entry': <FileText className="w-4 h-4" />,
    // 'legatrix': <Shield className="w-4 h-4" />,
    // 'sap-successfactors': <Database className="w-4 h-4" />,
    // 'sales-portal': <Building2 className="w-4 h-4" />,
    // 'srn-pod': <FileText className="w-4 h-4" />,
    // 'ff-workflow': <Zap className="w-4 h-4" />,
    // 'web-email': <Mail className="w-4 h-4" />,
    // 'workflow-automation': <Zap className="w-4 h-4" />,
    
    // Ethics & Compliance icons
    'speakup-line': <Phone className="w-4 h-4" />,
    'toolkits': <Settings className="w-4 h-4" />,
    
    // Contact icons
    'bangalore': <MapPin className="w-4 h-4" />,
    'mumbai': <MapPin className="w-4 h-4" />,
    'dhaka': <MapPin className="w-4 h-4" />,
    'colombo': <MapPin className="w-4 h-4" />,

    // Learning Centre dropdown icons
    'ai-hub': <Cpu className="w-4 h-4" />,
    'videos': <PlayCircle className="w-4 h-4" />,
    'learning-centre': <GraduationCap className="w-4 h-4" />,
  };

  return iconMap[itemId] || <ExternalLink className="w-4 h-4" />;
};

// Get dropdown width based on content
export const getDropdownWidth = (navId: string): string => {
  const widthMap: { [key: string]: string } = {
    'about': 'w-[800px]',
    'events': 'w-[200px]',
    // 'quick-links': 'w-[900px]',
    'ethics-compliance': 'w-[250px]',
    'contact': 'w-[250px]',
    'training': 'w-[220px]'
  };
  return widthMap[navId] || 'w-[400px]';
};

// Get dropdown left position to prevent overflow
export const getDropdownLeft = (dropdown: HTMLDivElement | null, initialLeft: number): number => {
  if (!dropdown) return initialLeft;
  
  const dropdownWidth = dropdown.offsetWidth;
  const viewportWidth = window.innerWidth;
  const containerPadding = 40;
  
  // Start with nav item's left position
  let leftPosition = initialLeft;
  
  // Prevent overflow on the left
  if (leftPosition < containerPadding) {
    leftPosition = containerPadding;
  }
  
  // Prevent overflow on the right
  if (leftPosition + dropdownWidth > viewportWidth - containerPadding) {
    leftPosition = viewportWidth - dropdownWidth - containerPadding;
  }
  
  return leftPosition;
};

// Calculate arrow position relative to dropdown
export const getArrowPosition = (
  dropdownPosition: { left: number; width: number }, 
  actualLeft: number
): number => {
  const navItemLeft = dropdownPosition.left;
  const navItemWidth = dropdownPosition.width;
  
  // Arrow should point to center of nav item
  const arrowLeft = navItemLeft + (navItemWidth / 2) - actualLeft - 8;
  
  return Math.max(20, Math.min(arrowLeft, 200)); // Keep arrow within reasonable bounds
};